import { resolveId } from '@medplum/core'
import type { Immunization, Reference } from '@medplum/fhirtypes'
import { referenceDisplay } from '@seen/core/display'
import { ExtendedImmunization } from '@seen/core/models/immunizations/ExtendedImmunization'
import { cn } from '@seen/ui'
import type { JSX } from 'react'
import { Link } from '#src/components/core/Link.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function ImmunizationMention({
  immunization: immunizationReference,
  className,
  displayOverride,
}: {
  immunization: Reference<Immunization>
  className?: string
  displayOverride?: string | null
}): JSX.Element {
  const immunizationId = resolveId(immunizationReference)

  const { data: immunization } = useRead(
    ExtendedImmunization,
    immunizationReference
  )
  const participantId = resolveId(immunization?.patient)
  const immunizationUrl =
    participantId && immunizationId
      ? `/Patient/${participantId}/immunizations/${immunizationId}`
      : undefined

  const displayText =
    displayOverride ??
    immunization?.vaccineDisplay ??
    referenceDisplay(immunizationReference)

  return (
    <Link
      to={immunizationUrl ?? '#'}
      className={cn(
        'select-none rounded-sm border-[0.5px] border-gray-450 bg-gray-470 box-decoration-clone px-1 py-px hover:bg-gray-460 group-[.ProseMirror-selectednode]:bg-[lch(53_52.26_286.91/0.4)] [&&]:no-underline',
        className
      )}
      tabIndex={-1}
      aria-disabled={!immunizationUrl}
    >
      <span>{displayText}</span>
    </Link>
  )
}
